import React, { memo } from 'react';
import { Box } from '@mui/material';

const InlineSpinner = memo(({ size = 40, innerGap = 4 }) => (
  <Box
    sx={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%',
      background: 'conic-gradient(from 0deg, #1976d2, #00bcd4, #4caf50, #1976d2)',
      animation: 'spin 1s linear infinite',
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: `${innerGap}px`,
        left: `${innerGap}px`,
        right: `${innerGap}px`,
        bottom: `${innerGap}px`,
        background: '#fafafa',
        borderRadius: '50%',
      },
      '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' },
      },
    }}
  />
));

export const Loader = memo(({ size = 40 }) => <InlineSpinner size={size} />);
